import autosize from 'autosize';

$(function(){
  autosize($('.autosize'));
});
